import { useScrollTrigger } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  CSSForFilterDropdown,
  CSSForSelect,
  CSSForSelect15vWWidth,
  CSSForSelect20vWWidth,
  DateRangePicker,
  formatDate,
  handleErrorToast,
  sortProjects,
  uploadFileInChunks,
  Addbutton,
  DeleteButton,
  ProgressModal,
} from "../CustomFunctions";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { toast, ToastContainer } from "react-toastify";
import {
  AddwithWhiteCircle,
  CircularGrid,
  Employee,
  Filter,
  Location,
  Office,
  ProjectIcon,
  UpdatePencil,

  AddwithBlueCircle,
  DeleteDustbin,
  DropdownArrow,
  CrossRed,
  Eye,

  CheckGreen,
  DropdownArrowOption,
  Attachment,
  DocumentIcon,
  CloseEye,
  CrosswithRedCircle,
  ArrowBullet,
  DocumentButton,
  DocumentfOLDIcon,
  DeleteDustbinbUTTON,
} from "../AllSvg";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { DocumentSection, statesAndUTs } from "../FormdataComponent";

import * as XLSX from "xlsx";
import { axiosInstance2 } from "../../config/axiosInstance";
import "./CertificateAccess.css";

/* Shared react-select styles for filter-bar dropdowns (compact) */
const caFilterSelectStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: "32px",
    minWidth: "170px",
    borderRadius: "5px",
    border: "1px solid #d0d7de",
    backgroundColor: "#fff",
    fontSize: "11.5px",
  }),
  menu: (provided) => ({ ...provided, fontSize: "11.5px", zIndex: 20 }),
};

/* Shared react-select styles for form fields */
const caSelectStyles = {
  control: (provided) => ({
    ...provided,
    width: "100%",
    minHeight: "36px",
    borderRadius: "6px",
    border: "1px solid #d0d7de",
    color: "#1a1a2e",
    backgroundColor: "#f7f8fa",
    padding: "0px 4px",
  }),
  placeholder: (provided) => ({ ...provided, color: "#4a4a4a" }),
  menu: (provided) => ({ ...provided, borderRadius: "8px", marginTop: "2px" }),
  singleValue: (provided) => ({ ...provided, color: "#4a4a4a" }),
  input: (provided) => ({ ...provided, color: "#4a4a4a" }),
};

const DeleteDocuments = ({ i, getDocument }) => {
  const [show, setshow] = useState(false);
  const handleClose = () => {
    setshow(false);
  };
  const [loading, setLoading] = useState(false);

  const handleShow = () => {
    setshow(true);
  };
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);


  const handleDelete = async (e) => {
    e.preventDefault();
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Deleting: please wait...");
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);
    try {
      const ress = await axios.delete(
        `${BASE_URL}/siteproject/documents/${i.id}/`
      );
      if (ress.status === 200) {
        await getDocument();
        handleClose();
        setTimeout(() => {
          toast.dismiss(loadingToastId);
          toast.success("Data deleted successfully.", {
            autoClose: 1000,
            pauseOnHover: true,
            closeOnClick: true,
          });
        }, 1000);
      } else {
        throw new Error("Unexpected response status: " + ress.status);
      }

    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
    } finally {
      clearInterval(interval);

      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);

      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="ca_btn--icon ca_btn--icon-danger" onClick={handleShow}>
        <DeleteDustbin />
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave width-40vw"
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete Document {i.document_name}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  Are You Sure You Want to delete Document {i.document_name}
                  <div className="ca_modal-footer">
                    <button className="ca_btn ca_btn--cancel" onClick={handleClose}>Cancel</button>
                    <DeleteButton onclick={handleDelete} />

                  </div>
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal>
            : ""
      }
    </>
  );
};

const DocumentModel = ({ officerent, vehicle, certificate, employee, getDocument, siteVehicle, employeeData, rentData, p_id, title, letter_tracking, letterData, letterrecord, usedFor, documents, setDocuments, projectsList, document_for }) => {
  const [show, setShow] = useState(false);
  const [toggleState, setToggleState] = useState(1);
  const [formData, setFormData] = useState([
    {
      document_name: "",
      document_file: null,
      original_filename: "",
      vehicledocs: vehicle ? vehicle : "",
      employeedocs: employee ? employee : "",
      miscellaneous_docs: p_id ? p_id : "",
      document_type: "",
      officerent: officerent ? officerent : "",
      letter_tracking: letter_tracking ? letter_tracking : "",
      letterrecord: letterrecord ? letterrecord : "",
      loa_copy: "",
      project: "null",
      certificate_copy: certificate ? certificate : "",
    },
  ]);
  const role = sessionStorage.getItem('sitemanagement_role')
  const [documenttype, setdocumenttype] = useState("null");



  useEffect(() => {
    if (title === "Documents" || title === "Letters" || title === `Letter Documents`) {
      setToggleState(2);
    }
  }, [title]);


  useEffect(() => {
    if (role === "ViewAccess") {
      setToggleState(2)
    }
  }, [role])

  const [uploadProgress, setUploadProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const fileInputRefs = useRef([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setFormData([
      {
        document_name: "",
        document_file: null,
        vehicledocs: vehicle || "",
        employeedocs: employee || "",
        miscellaneous_docs: p_id || "",
        original_filename: "",
        project: "null",
        document_type: "",
        officerent: officerent || "",
        letter_tracking: letter_tracking || "",
        letterrecord: letterrecord || "",
        certificate_copy: certificate || "",


      },
    ]);
  }, [vehicle, employee, p_id, officerent, letter_tracking, letterrecord, certificate]);





  const refresh = () => {
    setFormData(
      [{
        document_name: "",
        document_file: null,
        original_filename: "",
        project: "null",
        vehicledocs: vehicle ? vehicle : "",
        employeedocs: employee ? employee : "",
        miscellaneous_docs: p_id ? p_id : "",
        document_type: "",
        officerent: officerent ? officerent : "",
        letter_tracking: letter_tracking ? letter_tracking : "",
        letterrecord: letterrecord ? letterrecord : "",
        loa_copy: "",
        certificate_copy: certificate ? certificate : "",


      },]
    )
  }




  const handleShow = () => {
    setShow(true);
    if (title === "Letter Documents") {
      setDocuments(true);
    }
  };


  const handleClose = () => {
    setShow(false);
    if (title === "Letter Documents") {
      setDocuments(false)
    }

    if (title === "Letters" || title === "Documents" || role === "ViewAccess") {
      setToggleState(2);

    }
    else {

      setToggleState(1);
    }
    refresh();
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData];
      newDocuments[index] = {
        ...newDocuments[index],
        [name]: value,
      };
      return newDocuments;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };

  const [docNames, setDocNames] = useState([]);



  const handleFileChange = (e, index) => {
    const file = e.target.files[0];

    if (file) {

      const allowedTypes = [
        "application/pdf",
        "application/zip", "application/x-zip-compressed",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
        "image/png",
        "image/gif"
      ];

      if (!allowedTypes.includes(file.type) && !file.name.match(/\.(zip|pdf|xls|xlsx|png|gif)$/i)) {
        toast.error("Only ZIP, PDF, PNG, GIF and Excel files are allowed!");
        return;
      }


      const symbols = "!@#$%^&*()_-+=";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numbers = "0123456789";
      const now = new Date();
      const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-");
      const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-");
      const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;

      let randomCode = "";
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * allChars.length);
        randomCode += allChars[randomIndex];
      }

      const aimantraFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
      const customFile = new File([file], aimantraFileName, { type: file.type });


      setFormData((prevFormData) => {
        const newDocuments = [...prevFormData];
        newDocuments[index] = {
          ...newDocuments[index],
          document_file: customFile,
          original_filename: aimantraFileName,

        };
        return newDocuments;
      });


      setDocNames((prev) => {
        const newNames = [...prev];
        newNames[index] = aimantraFileName;
        return newNames;
      });


      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[`${index}-document_file`];
        delete newErrors[`${index}-original_filename`];
        return newErrors;
      });

    } else {

      setDocNames((prev) => {
        const newNames = [...prev];
        newNames[index] = "";
        return newNames;
      });

      setFormData((prevFormData) => {
        const newDocuments = [...prevFormData];
        newDocuments[index] = {
          ...newDocuments[index],
          document_file: null,
          original_filename: "",
        };
        return newDocuments;
      });
    }
  };


  const [letterNumberData, setLetterNumberData] = useState([]);


  const handleLetterChange = async (index, value) => {
    try {
      const updatedForm = [...formData];

      updatedForm[index] = {
        ...updatedForm[index],
        letterrecord: value || "null",
      };

      setFormData(updatedForm);

      // safely handle error clearing
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        if (typeof value === "string" && value.trim() !== "") {
          delete newErrors[`${index}-letterrecord`];
        }
        return newErrors;
      });


    } catch (error) {
      console.error("Error in handleProjectChange:", error);
    }
  };
  const handleProjectChange = async (index, value) => {
    try {
      const updatedForm = [...formData];

      updatedForm[index] = {
        ...updatedForm[index],
        project: value || "",
      };

      setFormData(updatedForm);

      // safely handle error clearing
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        if (typeof value === "string" && value.trim() !== "") {
          delete newErrors[`${index}-project`];
        }
        return newErrors;
      });

      if (value) {
        await fetchLetterNumber(index, value);
      }
    } catch (error) {
      console.error("Error in handleProjectChange:", error);
    }
  };



  const fetchLetterNumber = async (index, projectId) => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/letternum/${projectId}/`);

      setLetterNumberData((prev) => ({
        ...prev,
        [index]: res.data,
      }));
    } catch (error) {
      console.error("Error fetching letter number:", error);
    }
  };









  const addNewDocument = () => {
    setFormData((prevFormData) => [
      ...prevFormData,
      {
        document_name: "",
        document_file: null,
        vehicledocs: vehicle || "",
        original_filename: "",
        letterrecord: letterrecord || "",
        employeedocs: employee || "",
        miscellaneous_docs: p_id || "",
        document_type: "",
        officerent: officerent || "",
        letter_tracking: letter_tracking || "",
        loa_copy: "",
        certificate_copy: certificate || "",
        project: "",

      },
    ]);
    fileInputRefs.current.push(null);
  };


  const handleRemoveDocument = (index) => {
    setFormData((prevFormData) => prevFormData.filter((_, i) => i !== index));
    fileInputRefs.current.splice(index, 1);
  };

  const handleClear = (index) => {
    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData];
      newDocuments[index] = {
        ...newDocuments[index],
        document_file: null,
      };
      return newDocuments;
    });

    if (fileInputRefs.current[index]) {
      fileInputRefs.current[index].value = "";
    }
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[`${index}-document_file`];
      return newErrors;
    });
  };

  const validateForm = () => {
    const newErrors = {};

    formData.forEach((doc, index) => {
      if (!doc.document_name.trim()) {
        newErrors[`${index}-document_name`] = "Document Name is required!";
      }

      if (title !== "Miscellaneous Document" && title !== "Document" && title !== "Letter Attacments" && title !== "Bulk Documents" && !doc.document_type.trim()) {
        newErrors[`${index}-document_type`] = "Document Type is required ";
      }

      if (!doc.document_name.trim()) {
        newErrors[`${index}-document_name`] = "Document Name is required!";
      }
      if (
        title === "Bulk Documents" &&
        (doc.project === "null" || doc.project === "")
      ) {
        newErrors[`${index}-project`] = "Project Name is required!";
      }
      if (
        title === "Bulk Documents" &&
        (doc.letterrecord === "null" || doc.letterrecord === "")
      ) {
        newErrors[`${index}-letterrecord`] = "Letter Number is required!";
      }

      if (!doc.document_file) {
        newErrors[`${index}-document_file`] = "Document file is required!";
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  useEffect(() => {
    console.log("FormData updated:", formData);
  }, [formData]);

  useEffect(() => {
    console.log("p_id updated:", p_id);
  }, [p_id]);


  console.log(errors)


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true); //loading logic

      const loadingToastId = toast.loading("Uploading: please wait..."); //toast Logic

      const formDataToSend = new FormData();

      // formData.forEach((doc, index) => {

      // });

      for (let [index, doc] of formData.entries()) {
        formDataToSend.append(`documents[${index}].document_name`, doc.document_name);

        if (doc.employeedocs) {
          formDataToSend.append(`documents[${index}].employeedocs`, doc.employeedocs);
        }
        if (doc.vehicledocs) {
          formDataToSend.append(`documents[${index}].vehicledocs`, doc.vehicledocs);
        }
        // if (doc.miscellaneous_docs) {
        let fileIndex = 0;

        if (doc.document_file) {
          const fileId = await uploadFileInChunks(doc.document_file, doc.document_name, setUploadProgress);
          if (!fileId) {
            console.error(`❌ Failed to upload file: ${doc.document_name}`);
            continue; // Skip this file instead of returning
          }
          console.log(doc, "documents")
          formDataToSend.append("file_ids", fileId);
          formDataToSend.append(`documents[${fileIndex}][document_name]`, doc.document_name);
          // const fileNameWithoutExt = doc.document_file.name.substring(0, doc.document_file.name.lastIndexOf('.')) || doc.document_file.name;
          // formDataToSend.append(`documents[${fileIndex}][original_filename]`, doc.document_file.file);
          formDataToSend.append(`documents[${fileIndex}][original_filename]`, doc.document_file.name);

          fileIndex++; // Ensure indices remain correct


        }


        if (!formDataToSend.has("file_ids")) {
          console.error("❌ No valid files were uploaded.");
          setLoading(false);
          return;
        }

        // formDataToSend.append(`documents[${index}].miscellaneous_docs`, doc.miscellaneous_docs);
        // }
        if (doc.officerent) {
          formDataToSend.append(`documents[${index}].officerent`, doc.officerent);
        }
        if (doc.miscellaneous_docs) {
          formDataToSend.append(`documents[${index}].miscellaneous_docs`, doc.miscellaneous_docs);
        }
        if (doc.letter_tracking) {
          formDataToSend.append(`documents[${index}].letter_tracking`, doc.letter_tracking);
        }
        if (doc.letterrecord) {
          formDataToSend.append(`documents[${index}].letterrecord`, doc.letterrecord);
        }
        if (doc.loa_copy) {
          formDataToSend.append(`documents[${index}].loa_copy`, doc.loa_copy);
        }
        if (doc.certificate_copy) {
          formDataToSend.append(`documents[${index}].certificate_copy`, doc.certificate_copy);
        }
        if (doc.document_file) {
          formDataToSend.append(`documents[${index}].document_file`, doc.document_file);
        }
        if (document_for === "contractor") {
          formDataToSend.append(`documents[${index}].document_type`, "boq");
        }
        if (document_for === "consultant") {
          formDataToSend.append(`documents[${index}].document_type`, "actual");
        }
        if (doc.document_type) {
          formDataToSend.append(`documents[${index}].document_type`, doc.document_type);
        }

      }


      try {
        const response = await axiosInstance2.post(
          `/siteproject/documentbulk/`,
          formDataToSend,
          {
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(percentCompleted);
            },
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status === 200) {
          if (title === "LOA & Certificate Document") {
            getCompanyCreditData();
            setToggleState(2);
            refresh();
          }
          else if (title === "Letter Attacments") {
            getDocuments();
            setToggleState(2);
            refresh();
          }
          else {
            getDocument();
            getDocuments();
            handleClose();
            refresh();

          }



          toast.dismiss(loadingToastId);
          toast.success("Data added successfully.", {
            autoClose: 1000,
            pauseOnHover: true,
            closeOnClick: true,
          });
        }

      } catch (error) {
        // handleErrorToast(error);

      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);

        setUploadProgress(0);
      }
    }
  };

  const [DocumentData, setDocumentData] = useState([]);
  const getDocuments = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/documentwithletterget/${letterrecord}/`)
      setDocumentData(res.data)
    } catch (error) {
      console.error(error);

    }
  }
  const [filteredData, setFilteredData] = useState([]);
  const [CompanyCreditDocumentData, setCompanyCreditDocumentData] = useState([]);
  const getCompanyCreditData = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/documentmodelfiltercertificate/null/${certificate}/`
      );
      setCompanyCreditDocumentData(res.data);
      setFilteredData(res.data); // show all initially
    } catch (error) {
      console.error(error);
    }
  };

  console.log("letterrecord");
  console.log(letterrecord);


  console.log("letterData");
  console.log(letterData);

  useEffect(() => {
    if (show === true && letterrecord) {
      getDocuments();
    }
  }, [letterrecord, show])
  useEffect(() => {
    if (show === true && certificate) {
      getCompanyCreditData();
    }
  }, [certificate, show])

  console.log("uploadProgress");
  console.log(uploadProgress);

  console.log("formData")
  console.log(formData)

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setdocumenttype(value);

    if (value === "") {
      setFilteredData(CompanyCreditDocumentData);
    } else {
      const result = CompanyCreditDocumentData.filter(
        (item) => item.document_type === value
      );
      setFilteredData(result);
    }
  };
  const projectOption = [
    ...(Array.isArray(projectsList)
      ? projectsList.map((i) => ({
        value: i.id,
        label: `${i.site_prcode} - ${i.project_short_name}`,
      }))
      : []),
  ];
  const letterOptions = [
    ...(Array.isArray(letterNumberData)
      ? letterNumberData.map((i) => ({
        value: i.id,
        label: `${i.letter_num}`,
      }))
      : []),
  ];


  return (



    <>
      {role === "ViewAccess" ?
        <button title="View Document" className="ca_btn ca_btn--outline" onClick={handleShow}>
          View
        </button>
        : vehicle || officerent || title === "Document" || title === "LOA & Certificate Document" ?
          <>
            <button title="Add/View Document" className="ca_btn ca_btn--outline" onClick={handleShow}>
              Add/View
            </button>
          </>
          :
          (title === "Documents") ?
            <button
              onClick={handleShow}
              className="ca_btn--icon"
              title="View"
            >
              <span className="ca_view-text">View</span>
            </button>

            :
            (title === "Letters") ?
              <button title="View Document" className="ca_btn ca_btn--outline" onClick={handleShow}>
                View Letters
              </button>
              :
              (title === "Letter Attacments") ?
                <DocumentButton onclick={handleShow} />
                : (title === `Letter Documents`) ?
                  <button className="ca_btn ca_btn--outline" onClick={handleShow}>
                    View Letter Documents
                  </button> :
                  title === "Bulk Documents" ?
                    <button
                      className="ca_btn"
                      onClick={handleShow}
                    >
                      <AddwithWhiteCircle /> {""} {title}
                    </button> :
                    role !== "ViewAccess" ?
                      <button title="Add Document" className="ca_btn" onClick={handleShow}>
                        <AddwithWhiteCircle /> {""} {title}
                      </button> :
                      <button title="View Document" className="ca_btn ca_btn--outline" onClick={handleShow}>
                        View Documents
                      </button>
      }
      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton>
          <Modal.Title>

            {toggleState === 1 ? `Add ${title}` : `View ${title}`}



          </Modal.Title>
        </Modal.Header>
        <Modal.Body>

          {(title !== "Miscellaneous Document" && title !== "Documents" && title !== "Letters" && title !== "Letter Documents" && title !== "Bulk Documents" && role !== "ViewAccess") && (
            <div className="ca_modal-subtabbar">
              <div>
                <button
                  className={`ca_modal-subtab ${toggleState === 1 ? "ca_modal-subtab--active" : ""}`}
                  onClick={() => setToggleState(1)}
                >
                  Add {title}
                </button>

                <button
                  className={`ca_modal-subtab ${toggleState === 2 ? "ca_modal-subtab--active" : ""}`}
                  onClick={() => setToggleState(2)}
                >
                  View {title}
                </button>
              </div>
              <div>
                {title === "LOA & Certificate Document" && toggleState === 2 &&
                  <select className="ca_filter-select"
                    value={documenttype} onChange={handleStatusChange}>
                    <option value=''>All</option>
                    <option value='actual'>LOA Copy</option>
                    <option value='boq'>Certificate Copy</option>
                  </select>
                }
              </div>



            </div>


          )}
          {toggleState === 1 &&
            <div className="ca_table-actions-row">
              <button onClick={addNewDocument} className="ca_btn ca_btn--outline">
                <AddwithWhiteCircle />
                {" "} Another Document
              </button>
            </div>

          }
          <div>
            {
              toggleState === 1 ?
                <>
                  {formData.map((data, index) => (
                    <div className="ca_doc-row-grid" key={index}>
                      {title === "Bulk Documents" && (
                        <>
                          {/* Site Project */}
                          <div title="Site Projects" className="ca_form-field">
                            <label className="ca_form-label">
                              Site Project <span className="ca_required">*</span>
                            </label>
                            <Select
                              options={projectOption}
                              onChange={(selectedOption) => handleProjectChange(index, selectedOption?.value)}
                              value={projectOption.find((item) => item.value === data.project) || null}
                              placeholder="Select a Project"
                              isSearchable
                              isClearable
                              noOptionsMessage={() => "No other options"}
                              styles={caSelectStyles}
                            />
                            {errors[`${index}-project`] && (
                              <span className="ca_error-message">
                                {errors[`${index}-project`]}
                              </span>
                            )}
                          </div>

                          {/* Letter Number */}
                          <div title="Letter Number" className="ca_form-field">
                            <label className="ca_form-label">
                              Letter Number <span className="ca_required">*</span>
                            </label>
                            {/** Build letter options safely */}
                            {(() => {
                              const letterOptions =
                                letterNumberData[index]?.map((i) => ({
                                  value: i.id,
                                  label: i.letter_num,
                                })) || [];
                              return (
                                <Select
                                  options={letterOptions}
                                  onChange={(selectedOption) => handleLetterChange(index, selectedOption?.value)}
                                  value={letterOptions.find((item) => item.value === data.letterrecord) || null}
                                  placeholder="Select Letter Number"
                                  isSearchable
                                  isClearable
                                  noOptionsMessage={() => "No other options"}
                                  styles={caSelectStyles}
                                />
                              );
                            })()}
                            {errors[`${index}-letterrecord`] && (
                              <span className="ca_error-message">
                                {errors[`${index}-letterrecord`]}
                              </span>
                            )}
                          </div>
                        </>
                      )}

                      {/* Document Name */}
                      <div className="ca_form-field">
                        <label htmlFor="document_name" className="ca_form-label">
                          Document Name<span className="ca_required">*</span>
                        </label>
                        <input
                          type="text"
                          name="document_name"
                          value={data.document_name}
                          onChange={(e) => handleInputChange(e, index)}
                          placeholder="Document Name"
                          className="ca_input"
                        />
                        {errors[`${index}-document_name`] && (
                          <span className="ca_error-message">
                            {errors[`${index}-document_name`]}
                          </span>
                        )}
                      </div>

                      {/* Document Type */}
                      {title !== "Miscellaneous Document" &&
                        title !== "Document" &&
                        title !== "Letter Attacments" &&
                        title !== "Bulk Documents" && (
                          <div title="Document Type" className="ca_form-field">
                            <label
                              htmlFor="document_type"
                              className="ca_form-label"
                            >
                              Document Type <span className="ca_required">*</span>
                            </label>
                            <select
                              id="document_type"
                              name="document_type"
                              value={data.document_type}
                              onChange={(e) => handleInputChange(e, index)}
                              className="ca_select"
                            >
                              <option value="">Select Document Type</option>
                              {title !== "LOA & Certificate Document" ? (
                                <>
                                  <option value="actual">Actual Document</option>
                                  <option value="boq">Boq Document</option>
                                </>
                              ) : (
                                <>
                                  <option value="actual">LOA Copy</option>
                                  <option value="boq">Certificate Copy</option>
                                </>
                              )}
                            </select>
                            {errors[`${index}-document_type`] && (
                              <span className="ca_error-message">
                                {errors[`${index}-document_type`]}
                              </span>
                            )}
                          </div>
                        )}

                      {/* File Upload */}
                      <div className="ca_form-field">
                        {!data.document_file && (
                          <label
                            htmlFor={`document_file_${index}`}
                            className="ca_form-label"
                          >
                            Upload Document<span className="ca_required">*</span>
                          </label>
                        )}

                        <div className="ca_doc-form-row" style={{ gridTemplateColumns: "auto 1fr" }}>
                          {!data.document_file && (
                            <div>
                              <label htmlFor={`document_file_${index}`} className="ca_doc-upload-label">
                                <Attachment />
                              </label>
                              <input
                                type="file"
                                id={`document_file_${index}`}
                                name="document_file"
                                accept=".zip, .pdf, .xls, .xlsx, .gif"
                                style={{ display: "none" }}
                                onChange={(e) => handleFileChange(e, index)}
                                ref={(el) => (fileInputRefs.current[index] = el)}
                              />
                            </div>
                          )}

                          {data.document_file && (
                            <div className="ca_tooltip-wrap">
                              <span className="ca_tooltip-text">{data.original_filename}</span>
                              !
                            </div>
                          )}
                        </div>
                        {errors[`${index}-document_file`] && (
                          <span className="ca_error-message">
                            {errors[`${index}-document_file`]}
                          </span>
                        )}
                      </div>

                      {/* Clear / Remove Buttons */}
                      <div className="ca_form-field" style={{ flexDirection: "row", gap: "8px" }}>
                        <button
                          title="Clear File"
                          onClick={() => handleClear(index)}
                          className="ca_btn ca_btn--cancel"
                        >
                          Clear
                        </button>
                        {formData.length > 1 && (
                          <button
                            title="Remove Document"
                            onClick={() => handleRemoveDocument(index)}
                            className="ca_btn ca_btn--cancel"
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    </div>
                  ))}


                  {uploadProgress > 0 && (
                    <div className="ca_progress-wrap">
                      <div className="ca_progress-label">Uploading {uploadProgress}%</div>
                      <div className="ca_progress-track">
                        <div className="ca_progress-fill" style={{ width: `${uploadProgress}%` }}></div>
                      </div>
                    </div>
                  )}

                  <div className="ca_modal-footer">
                    <button className="ca_btn ca_btn--cancel" onClick={handleClose}>Cancel</button>

                    <Addbutton onclick={handleSubmit} />
                  </div>
                </> :
                <>

                  <div className='ca_table-scroll'>

                    <table className="ca_table">
                      <thead>
                        <tr>
                          <th className="ca_th">S.No.</th>
                          <th className="ca_th">Document Name</th>
                          {(title !== "Miscellaneous Document" && title !== "LetterTracking" && title !== "Documents" && title !== "Letters" && title !== "Letter Attacments" && title !== "Letter Documents" && title !== "Document") &&
                            <th className="ca_th">Document Type</th>
                          }
                          <th className="ca_th ca_th--center">Document</th>
                          {(title !== "Miscellaneous Document" && title !== "LetterTracking" && title !== "Documents" && title !== "Letters" && title !== "Letter Documents" && role !== "ViewAccess") &&
                            <th className="ca_th ca_th--right">Action</th>
                          }
                        </tr>
                      </thead>

                      <tbody
                      >
                        {vehicle && (

                          siteVehicle
                            .filter((v) => v.id === vehicle)
                            .flatMap((v) => v.documents)
                            .filter((doc) => doc.vehicledocs === vehicle)
                            .map((doc, docIndex) => (
                              <React.Fragment key={docIndex}>
                                <tr className="ca_row">
                                  <td className="ca_td">{docIndex + 1}.</td>
                                  <td className="ca_td">{doc.document_name}</td>
                                  <td className="ca_td">{doc.document_type}</td>
                                  <td className="ca_td ca_td--center">
                                    {doc.document_file ? (



                                      <a href={doc.document_file} target="blank" className="ca_doc-link">
                                        <DocumentIcon />
                                      </a>
                                    ) : (
                                      <span className="ca_doc-nofile">Document Not Attached</span>
                                    )}
                                  </td>
                                  {role !== "ViewAccess" &&
                                    <td className="ca_td ca_td--right">

                                      <DeleteDocuments i={doc} getDocument={getDocument} />
                                    </td>
                                  }
                                </tr>
                              </React.Fragment>

                            ))
                        )}
                        {certificate && (
                          filteredData.map((doc, docIndex) => (
                            <React.Fragment key={docIndex}>
                              <tr className="ca_row">
                                <td className="ca_td">{docIndex + 1}.</td>
                                <td className="ca_td">{doc.document_name}</td>
                                <td className="ca_td">{doc.document_type === "actual" ? "LOA Copy" : "Certiciate Copy"}</td>
                                <td className="ca_td ca_td--center">
                                  {doc.document_file ? (
                                    <a href={doc.document_file} target="blank" className="ca_doc-link">
                                      <DocumentIcon />
                                    </a>
                                  ) : (
                                    <span className="ca_doc-nofile">Document Not Attached</span>
                                  )}
                                </td>
                                <td className="ca_td ca_td--right">

                                  <DeleteDocuments i={doc} getDocument={getCompanyCreditData} />
                                </td>

                              </tr>
                            </React.Fragment>

                          ))
                        )}
                        {employee && (
                          employeeData.document
                            .map((doc, docIndex) => (
                              <React.Fragment key={docIndex}>
                                <tr className="ca_row">
                                  <td className="ca_td">{docIndex + 1}</td>
                                  <td className="ca_td ca_td--center">{doc.document_name}</td>
                                  <td className="ca_td ca_td--center">{doc.document_type}</td>
                                  <td className="ca_td ca_td--center">
                                    {doc.document_file ? (
                                      <a href={doc.document_file} target="_blank" rel="noopener noreferrer" className="ca_doc-link">
                                        <DocumentIcon />
                                      </a>
                                    ) : (
                                      <span className="ca_doc-nofile">Document Not Attached</span>
                                    )}
                                  </td>
                                  {role !== "ViewAccess" &&
                                    <td className="ca_td ca_td--right">
                                      <DeleteDocuments i={doc} getDocument={getDocument} />
                                    </td>
                                  }
                                </tr>
                              </React.Fragment>
                            ))
                        )}
                        {officerent && (
                          rentData?.filter((v) => v.id === officerent)
                            .flatMap((v) => v?.documents)
                            .filter((doc) => doc.officerent === officerent) // Ensure the document belongs to the vehicle
                            .map((doc, docIndex) => (
                              <React.Fragment key={docIndex}>
                                <tr className="ca_row">
                                  <td className="ca_td">{docIndex + 1}.</td>
                                  <td className="ca_td">{doc.document_name}</td>
                                  <td className="ca_td">{doc.document_type}</td>
                                  <td className="ca_td ca_td--center">
                                    {doc.document_file ? (
                                      <a href={doc.document_file} target="blank" className="ca_doc-link">
                                        <DocumentIcon />
                                      </a>
                                    ) : (
                                      <span className="ca_doc-nofile">Document Not Attached</span>
                                    )}
                                  </td>
                                  {role !== "ViewAccess" &&
                                    <td className="ca_td ca_td--right">
                                      <DeleteDocuments i={doc} getDocument={getDocument} />
                                    </td>
                                  }
                                </tr>
                              </React.Fragment>

                            ))
                        )}
                        {letter_tracking && (
                          letterData?.filter((v) => v.id === letter_tracking) // Find the vehicle that matches the passed vehicle ID
                            .flatMap((v) => v?.documents) // Get the documents for the matched vehicle
                            .map((doc, docIndex) => (
                              <React.Fragment key={docIndex}>
                                <tr className="ca_row">
                                  <td className="ca_td">{docIndex + 1}.</td>
                                  <td className="ca_td">{doc.document_name}</td>
                                  <td className="ca_td ca_td--center">
                                    {doc.document_file ? (
                                      <a href={doc.document_file} target="blank" className="ca_doc-link">
                                        <DocumentIcon />
                                      </a>
                                    ) : (
                                      <span className="ca_doc-nofile">Document Not Attached</span>
                                    )}
                                  </td>
                                  {title === "Document" && role !== "ViewAccess" &&
                                    <td className="ca_td ca_td--right">
                                      <DeleteDocuments i={doc} getDocument={getDocument} />
                                    </td>
                                  }

                                </tr>
                              </React.Fragment>

                            ))
                        )}
                        {letterrecord && (
                          DocumentData
                            .map((doc, docIndex) => (
                              <React.Fragment key={docIndex}>
                                <tr className="ca_row">
                                  <td className="ca_td">{docIndex + 1}.</td>
                                  <td className="ca_td">{doc.document_name}</td>
                                  <td className="ca_td ca_td--center">
                                    {doc.document_file ? (
                                      <a href={doc.document_file} target="blank" className="ca_doc-link">
                                        <DocumentfOLDIcon />
                                      </a>
                                    ) : (
                                      <span className="ca_doc-nofile">Document Not Attached</span>
                                    )}
                                  </td>
                                  {(title !== "Miscellaneous Document" && title !== "LetterTracking" && title !== "Documents" && title !== "Letters" && title !== "Letter Documents" && role !== "ViewAccess") &&

                                    <td className="ca_td ca_td--right">
                                      <DeleteDocuments i={doc} getDocument={getDocuments} />
                                    </td>
                                  }
                                </tr>
                              </React.Fragment>

                            ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </>
            }
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal >

    </>


  );
};

const UploadCompanyCredit = ({
  getData,
  getContractorProjects,
  subcompanyList,
}) => {
  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState("");
  const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
  const [docErrors, setDocErrors] = useState({});
  const [docInputState, setDocInputState] = useState({});

  const bulktableRef = useRef(null);
  const handleDownload = () => {
    const headers = [
      "project_code",
      "project_name",
      "sub_company",
      "project_short_name",
      "project_type",
      "state",
      "client",
      "project_length",
      "lane",
      "special_structure",
      "participate_as",
      "share_mention_on_clientcertificate",
      "share_asper_certificate",
      "CA_Certificate_available",
      "share_as_per_ca_certificate",
      "project_cost_cr",
      "total_consultancy_fees_cr",
      "completion_date",
      "remark",
    ].filter(Boolean);

    const data = [
      headers,
      [],
      ["REFERENCES:"],
      [],
      ["GENERAL INSTRUCTIONS:"],
      ["   • Project code must be unique."],
      ["   • Project length (in KM): enter only numbers."],
      ["   • Lane: enter only numbers (e.g., 2, 4, 6, 8)."],
      ["   • In share_mention_on_clientcertificate, enter 'true' or 'false'."],
      ["   • In CA_Certificate_available, enter 'true' or 'false'."],
      [
        "   • In share_asper_certificate and share_as_per_ca_certificate, enter numbers (e.g., 50, 60, 70). Do not enter percentages (e.g., 50%).",
      ],
      [
        "   • In project_cost_cr and total_consultancy_fees_cr, enter the cost in crores. For example, if the cost is 5 crores, just type 5.",
      ],

      [],

      [" Company OPTIONS:"],
      ...(Array.isArray(subcompanyList) && subcompanyList.length > 0
        ? subcompanyList.map((r) => [`   • ${r.title}`])
        : []),
      [],
      [" State OPTIONS:"],
      ...(Array.isArray(statesAndUTs) && statesAndUTs.length > 0
        ? statesAndUTs.map((r) => [`   • ${r}`])
        : []),
      [],
      ["NOTE: All Dates should be in DD-MM-YYYY format."],
      [],

      ["Delete all references before uploading."],
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Company Credential Format");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

    const blob = new Blob([s2ab(wbout)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Company Credential Format.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  const handleClose = () => {
    setFileName("");
    setExcelJson(null);
    setDocErrors({});
    setShow(false);
  };
  const handleShow = () => setShow(true);

  // Function to handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check for valid file type
      const validFileTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
      if (!validFileTypes.includes(file.type)) {
        setDocErrors({
          document_file: "Please upload a valid Excel file (.xlsx or .xls).",
        });
        setFileName("");
        return;
      }

      setFileName(file.name);
      readExcel(file); // Convert the file to JSON
    } else {
      setFileName("");
    }
  };

  const readExcel = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: null,
      });

      const headers = json[0];
      const rows = json.slice(1);

      const convertToYYYYMMDD = (input) => {
        try {
          let date;
          if (typeof input === "number") {
            const excelEpoch = new Date(1900, 0, 1);
            const daysOffset = input - 1;
            date = new Date(excelEpoch.getTime() + daysOffset * 86400000);
          } else if (/^\d{4}\.\d{2}\.\d{2}$/.test(input)) {
            const [year, month, day] = input.split(".");
            date = new Date(`${year}-${month}-${day}`);
          } else if (/^\d{2}\.\d{2}\.\d{4}$/.test(input)) {
            const [day, month, year] = input.split(".");
            date = new Date(`${year}-${month}-${day}`);
          } else {
            date = new Date(input);
          }
          if (isNaN(date.getTime())) throw new Error("Invalid date");
          return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        } catch {
          return null;
        }
      };

      // Filter out completely empty rows
      const filteredRows = rows.filter((row) =>
        row.some((cell) => cell !== null && cell !== undefined && cell !== ""),
      );

      const formattedJson = filteredRows.map((row) => {
        const obj = {};
        headers.forEach((header, index) => {
          let value = row[index] !== undefined ? row[index] : null;

          if (
            ["completion_date"].includes(header) &&
            value &&
            typeof value === "number"
          ) {
            value = convertToYYYYMMDD(value);
          }

          if (header === "state") {
            obj["length"] = value; // 👈 put state data into length
          } else {
            obj[header] = value;
          }
        });
        return obj;
      });

      setExcelJson(formattedJson);
    };
    reader.readAsArrayBuffer(file);
  };

  // Function to handle the upload button click
  const handleUpload = async () => {
    if (excelJson) {
      const loadingToastId = toast.loading("Uploading: Please wait...");
      try {
        const res = await axios.post(
          `${BASE_URL}/siteproject/certificatebulkcreate/`,
          excelJson,
        );
        if (res.status === 201) {
          await getData();
          handleClose();
          toast.dismiss(loadingToastId);
          toast.success("Data uploaded successfully.");
        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to add data!");
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    } else {
      setDocErrors({ document_file: "Please upload a valid Excel file." });
    }
  };

  return (
    <>
      <button
        title="Upload"
        className="ca_btn ca_btn--outline"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="20"
          id="upload"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
          </g>
        </svg>
        {" "}Upload
      </button>

      <Modal show={show} dialogClassName="ourcompany-model">
        <Modal.Body>
          <div className="ca_header" style={{ padding: "0 0 12px" }}>
            <Modal.Title className="ca_modal-section-title" style={{ border: "none", margin: 0 }}>
              Upload Company Credential Details in Bulk
            </Modal.Title>

            <button
              onClick={handleDownload}
              className="ca_btn ca_btn--outline"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="20"
                id="download"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                </g>
              </svg>
              {"  "} Format
            </button>
          </div>

          <div className="ca_upload-table-preview" style={{ display: excelJson ? "block" : "none" }}>
            <table className="ca_table">
              <thead>
                <tr>
                  <th className="ca_th">project_code</th>
                  <th className="ca_th">project_name</th>
                  <th className="ca_th">sub_company</th>
                  <th className="ca_th">project_short_name</th>
                  <th className="ca_th">project_type</th>
                  <th className="ca_th">state</th>
                  <th className="ca_th">client</th>
                  <th className="ca_th">project_length</th>
                  <th className="ca_th">lane</th>
                  <th className="ca_th">special_structure</th>
                  <th className="ca_th">participate_as</th>
                  <th className="ca_th">
                    share_mention_on_clientcertificate
                  </th>
                  <th className="ca_th">
                    share_asper_certificate
                  </th>
                  <th className="ca_th">
                    CA_Certificate_available
                  </th>
                  <th className="ca_th">
                    share_as_per_ca_certificate
                  </th>
                  <th className="ca_th">project_cost_cr</th>
                  <th className="ca_th">
                    total_consultancy_fees_cr
                  </th>
                  <th className="ca_th">completion_date</th>
                  <th className="ca_th">remark</th>
                </tr>
              </thead>
              <tbody>
                {excelJson?.map((project, index) => (
                  <tr key={index} className="ca_row">
                    <td className="ca_td">
                      {project.project_code}
                    </td>
                    <td className="ca_td">
                      {project.project_name}
                    </td>
                    <td className="ca_td">
                      {project.sub_company}
                    </td>
                    <td className="ca_td">
                      {project.project_short_name}
                    </td>
                    <td className="ca_td">
                      {project.project_type}
                    </td>
                    <td className="ca_td">{project.length}</td>
                    <td className="ca_td">{project.client}</td>
                    <td className="ca_td">
                      {project.project_length}
                    </td>
                    <td className="ca_td">{project.lane}</td>
                    <td className="ca_td">
                      {project.special_structure}
                    </td>
                    <td className="ca_td">
                      {project.participate_as}
                    </td>
                    <td className="ca_td">
                      {project.share_mention_on_clientcertificate
                        ? "true"
                        : "false"}
                    </td>
                    <td className="ca_td">
                      {project.share_asper_certificate}
                    </td>
                    <td className="ca_td">
                      {project.CA_Certificate_available ? "true" : "false"}
                    </td>
                    <td className="ca_td">
                      {project.share_as_per_ca_certificate}
                    </td>
                    <td className="ca_td">
                      {project.project_cost_cr}
                    </td>
                    <td className="ca_td">
                      {project.total_consultancy_fees_cr}
                    </td>
                    <td className="ca_td">
                      {project.completion_date
                        ? formatDate(project.completion_date)
                        : "-"}
                    </td>
                    <td className="ca_td">{project.remark}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="ca_form-field">
            <label
              htmlFor="document_file"
              className="ca_form-label"
            >
              Upload File
            </label>
            <label
              htmlFor="document_file"
              className="ca_doc-upload-label"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                  stroke="#707070"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </label>
            <input
              id="document_file"
              name="document_file"
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              style={{ display: "none" }}
            />
            {fileName && <p className="ca_doc-filename">{fileName}</p>}
            {docErrors.document_file && (
              <span className="ca_error-message">
                {docErrors.document_file}
              </span>
            )}
          </div>

          <div className="ca_modal-footer">
            <button
              className="ca_btn ca_btn--cancel"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="ca_btn"
              onClick={handleUpload}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="20"
                id="upload"
              >
                <g
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                </g>
              </svg>
              {"  "} Upload
            </button>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const Addformat = ({ getFormat, toggleCompany, siteSubCompanyList }) => {
  const [show, setShow] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const [showMoreDetails, setShowMoreDetails] = useState(false);

  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  const [formData, setFormData] = useState({
    project: null,
    project_code: "",
    project_short_name: "",
    project_type: "",
    project_name: "",
    client: "",
    project_length: "",
    lane: "",
    length: "",
    special_structure: "",
    participate_as: "",
    share_mention_on_clientcertificate: false,
    share_asper_certificate: "",
    CA_Certificate_available: false,
    share_as_per_ca_certificate: "",
    project_cost_cr: "",
    total_consultancy_fees_cr: "",
    completion_date: null,
    remark: "",
    LOA_copy_multiple: [{ document_name: "", document_file: "" }],
    certificate_copy_multiple: [{ document_name: "", document_file: "" }],
    sub_company: "null",
  });
  const [projectbyId, setProjectbyID] = useState("null");

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [projectList, setProjectList] = useState([]);

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = ["sub_company"];

    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field] === "null") {
        newErrors[field] =
          `${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };
  console.log("errors");
  console.log(errors);
  const getProject = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const pro = await axios.get(
        `${BASE_URL}/siteproject/projectfilterbysubcompany/${formData.sub_company}/`,
      );
      const sortedList = sortProjects(pro.data, "site_prcode");
      setProjectList(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    if (formData.sub_company) {
      getProject();
    }
  }, [formData.sub_company]);

  useEffect(() => {
    if (formData.project && projectbyId) {
      setFormData((prevData) => ({
        ...prevData,
        project_short_name: projectbyId.project_short_name,
        project_name: projectbyId.project_name,
        project_code: projectbyId.site_prcode,
        project_type: projectbyId.work_type,
        client: projectbyId.client_name,
        project_length: projectbyId.project_length,
        length: projectbyId.location,
      }));
    }
  }, [formData.project, projectbyId]);

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      project_short_name: "",
      project_name: "",
      project_code: "",
      project_type: "",
      client: "",
      project_length: "",
      length: "",
      project: null,
    }));
  }, [formData.sub_company]);

  useEffect(() => {
    if (formData.project === "null") {
      setFormData((prevData) => ({
        ...prevData,
        project_short_name: "",
        project_full_name: "",
        project_code: "",
        project_type: "",
        length: "",
        client: "",
        project_length: "",
      }));
    }
  }, [formData.project]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      sub_company: toggleCompany,
    }));
  }, [toggleCompany]);

  const getProjectbyID = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/projectbyid/${formData.project}/`,
      );
      setProjectbyID(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (formData.project !== "null") {
      getProjectbyID();
    }
  }, [formData.project]);

  const handleDocInputChange = (index, e) => {
    const { name, value, files } = e.target;

    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData.documents];
      newDocuments[index] = {
        ...newDocuments[index],
        [name]: files ? files[0] : value, // Removed .trim()
      };

      if (files) {
        setFileNames((prevFileNames) => {
          const newFileNames = [...prevFileNames];
          newFileNames[index] = files[0]?.name || "";
          return newFileNames;
        });
      }

      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        if (name === "document_name" && value.trim()) {
          delete updatedErrors[`document_name_${index}`];
        }
        if (name === "document_file" && files?.[0]) {
          delete updatedErrors[`document_file_${index}`];
        }
        return updatedErrors;
      });

      return { ...prevFormData, documents: newDocuments };
    });
  };

  const handleAddDocuments = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: [
        ...prevFormData.documents,
        { document_name: "", document_file: null },
      ],
    }));
  };

  const handleRemoveDocument = (index) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: prevFormData.documents.filter((_, i) => i !== index),
    }));
    setFileNames((prevFileNames) =>
      prevFileNames.filter((_, i) => i !== index),
    );
  };

  const [loading, setLoading] = useState(false);

  const [uploadProgress, setUploadProgress] = useState(0); // For upload progress

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      // const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        const res = await axiosInstance2.post(
          `${BASE_URL}/siteproject/certificate/`,
          formData,
          {
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
              setUploadProgress(percentCompleted);
            },
          },
        );

        if (res.status === 201) {
          await getFormat();
          toast.success("Data uploaded successfully!");
          handleClose();
        }
      } catch (err) {
        toast.error("Error uploading documents");
        console.error("Error uploading documents", err);
      } finally {
        setLoading(false);
        // toast.dismiss(loadingToastId);
        setUploadProgress(0);
      }
    }
  };

  const handleInputChange = (e, index) => {
    const { name, value, type, checked, options } = e.target;

    let newValue;
    if (type === "select-multiple") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    // Update input state with feedback
    setInputState((prevState) => ({
      ...prevState,
      [name]:
        type === "checkbox"
          ? checked
            ? "green"
            : ""
          : newValue
            ? "green"
            : "",
    }));

    // Update form data with dynamic calculations
    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,
      };
      return updatedFormData;
    });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (value.trim()) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };

  const ProjectListOption = projectList
    ?.sort((a, b) => a.site_prcode.localeCompare(b.site_prcode))
    .map((i) => ({
      value: i.id,
      label: `${i.site_prcode} - ${i.project_short_name}`,
    }));

  const sortedStatesAndUTs = [...statesAndUTs].sort();

  const [location, setLocation] = useState([]);

  useEffect(() => {
    const uniqueLocations = [
      ...new Set(
        sortedStatesAndUTs
          .map((item) => item?.trim())
          .filter((type) => type && type !== ""),
      ),
    ]
      .sort((a, b) => a.localeCompare(b))
      .map((type) => ({ location: type }));

    setLocation(uniqueLocations);
  }, [statesAndUTs]);

  const StatesOptions = location
    ?.sort((a, b) => a.location.localeCompare(b.location))
    .map((i) => ({
      value: i.location,
      label: `${i.location}`,
    }));

  const handleLocationChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        length: "",
      });
    } else {
      setFormData({
        ...formData,
        length: selectedOption.value,
      });
    }
  };
  const handleProjectChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        project: "",
      });
    } else {
      setFormData({
        ...formData,
        project: selectedOption.value,
      });
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.project;
      return updatedErrors;
    });
  };

  console.log("formData");
  console.log(formData);
  return (
    <>
      <button
        title="Add Company Credential"
        className="ca_btn"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> Company Credential
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Company Credential Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ca_modal-section-title">Required Information</div>
          <div className="ca_form-grid">
            <div title="Site Sub Company" className="ca_form-field">
              <label htmlFor="sub_company" className="ca_form-label">
                Site Sub Company <span className="ca_required">*</span>
              </label>
              <select
                id="sub_company"
                name="sub_company"
                value={formData.sub_company}
                onChange={handleInputChange}
                className={`ca_select ${errors.sub_company
                  ? "ca_select--error"
                  : inputState.sub_company
                    ? "ca_select--success"
                    : ""
                  }`}
              >
                <option value="null">Select a Site SubCompany</option>
                {siteSubCompanyList
                  ?.sort((a, b) =>
                    a.title.localeCompare(b.title, "en", {
                      ignorePunctuation: true,
                    }),
                  )
                  .map((i, index) => (
                    <option value={i.id} key={index}>{i.title}</option>
                  ))}
              </select>
              {errors.sub_company && (
                <span className="ca_error-message">
                  {errors.sub_company}
                </span>
              )}
            </div>

            <div title="Project" className="ca_form-field">
              <label htmlFor="project" className="ca_form-label">
                Project
              </label>
              <Select
                options={ProjectListOption}
                onChange={handleProjectChange}
                value={
                  formData.project === "null" ||
                    formData.project === undefined
                    ? "null"
                    : ProjectListOption.find(
                      (option) => option.value === formData.project,
                    )
                }
                placeholder="Select a Project"
                isSearchable
                isClearable
                noOptionsMessage={() => "No other options"}
                styles={caSelectStyles}
              />
              {errors.project && (
                <span className="ca_error-message">
                  {errors.project}
                </span>
              )}
            </div>

            <div title="project_code" className="ca_form-field">
              <label htmlFor="project_code" className="ca_form-label">
                Project Code
              </label>
              <input
                type="text"
                maxLength={100}
                id="project_code"
                name="project_code"
                placeholder="Project Code"
                onChange={handleInputChange}
                value={formData.project_code}
                className={`ca_input ${errors.project_code
                  ? "ca_input--error"
                  : inputState.project_code
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.project_code && (
                <span className="ca_error-message">
                  {errors.project_code}
                </span>
              )}
            </div>

            <div title="project_short_name" className="ca_form-field">
              <label htmlFor="project_short_name" className="ca_form-label">
                Project Short Name
              </label>
              <input
                type="text"
                maxLength={100}
                id="project_short_name"
                name="project_short_name"
                placeholder="Project Short Name"
                onChange={handleInputChange}
                value={formData.project_short_name}
                className={`ca_input ${errors.project_short_name
                  ? "ca_input--error"
                  : inputState.project_short_name
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.project_short_name && (
                <span className="ca_error-message">
                  {errors.project_short_name}
                </span>
              )}
            </div>

            <div title="project_name" className="ca_form-field ca_form-field--full">
              <label htmlFor="project_name" className="ca_form-label">
                Project Full Name
              </label>
              <textarea
                id="project_name"
                name="project_name"
                placeholder="Project Full Name"
                onChange={handleInputChange}
                value={formData.project_name}
                className={`ca_textarea ${errors.project_name
                  ? "ca_input--error"
                  : inputState.project_name
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.project_name && (
                <span className="ca_error-message">
                  {errors.project_name}
                </span>
              )}
            </div>

            <div title="client" className="ca_form-field">
              <label htmlFor="client" className="ca_form-label">
                Client
              </label>
              <input
                type="text"
                maxLength={100}
                id="client"
                name="client"
                placeholder="Client"
                onChange={handleInputChange}
                value={formData.client}
                className={`ca_input ${errors.client ? "ca_input--error" : inputState.client ? "ca_input--success" : ""
                  }`}
              />
              {errors.client && (
                <span className="ca_error-message">
                  {errors.client}
                </span>
              )}
            </div>

            <div title="Completion Date" className="ca_form-field">
              <label htmlFor="completion_date" className="ca_form-label">
                Completion Date
              </label>
              <input
                type="date"
                id="completion_date"
                name="completion_date"
                onChange={handleInputChange}
                value={formData.completion_date}
                className={`ca_input ${errors.completion_date
                  ? "ca_input--error"
                  : inputState.completion_date
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.completion_date && (
                <span className="ca_error-message">
                  {errors.completion_date}
                </span>
              )}
            </div>
          </div>

          <div className="ca_disclosure">
            <button
              type="button"
              className="ca_disclosure-toggle"
            // onClick={() => setShowMoreDetails((p) => !p)}
            >
              Additional Details (Optional)
              {/* <span className={`ca_expand-arrow ${showMoreDetails ? "ca_expand-arrow--open" : ""}`}>▼</span> */}
            </button>
            <div className={`ca_disclosure-body `}>
              <div className="ca_form-grid">
                <div title="project_type" className="ca_form-field">
                  <label htmlFor="project_type" className="ca_form-label">
                    Project Type
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="project_type"
                    name="project_type"
                    placeholder="Project type"
                    onChange={handleInputChange}
                    value={formData.project_type}
                    className={`ca_input ${errors.project_type
                      ? "ca_input--error"
                      : inputState.project_type
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.project_type && (
                    <span className="ca_error-message">
                      {errors.project_type}
                    </span>
                  )}
                </div>

                <div title="State" className="ca_form-field">
                  <label htmlFor="length" className="ca_form-label">
                    State
                  </label>
                  <Select
                    options={StatesOptions}
                    onChange={handleLocationChange}
                    value={StatesOptions.find(
                      (option) => option.value === formData.length,
                    )}
                    placeholder="Select a Location"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No other options"}
                    styles={caSelectStyles}
                  />
                  {errors.length && (
                    <span className="ca_error-message">
                      {errors.length}
                    </span>
                  )}
                </div>

                <div title="project_length" className="ca_form-field">
                  <label htmlFor="project_length" className="ca_form-label">
                    Project Length
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="project_length"
                    name="project_length"
                    placeholder="Project Length"
                    onChange={handleInputChange}
                    value={formData.project_length}
                    className={`ca_input ${errors.project_length
                      ? "ca_input--error"
                      : inputState.project_length
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.project_length && (
                    <span className="ca_error-message">
                      {errors.project_length}
                    </span>
                  )}
                </div>

                <div title="lane" className="ca_form-field">
                  <label htmlFor="lane" className="ca_form-label">
                    Lane
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="lane"
                    name="lane"
                    placeholder="Lane"
                    onChange={handleInputChange}
                    value={formData.lane}
                    className={`ca_input ${errors.lane ? "ca_input--error" : inputState.lane ? "ca_input--success" : ""
                      }`}
                  />
                  {errors.lane && (
                    <span className="ca_error-message">
                      {errors.lane}
                    </span>
                  )}
                </div>

                <div title="project_cost_cr" className="ca_form-field">
                  <label htmlFor="project_cost_cr" className="ca_form-label">
                    Project Cost (in Crores)
                  </label>
                  <input
                    type="number"
                    maxLength={100}
                    id="project_cost_cr"
                    name="project_cost_cr"
                    placeholder="Project Cost"
                    onChange={handleInputChange}
                    value={formData.project_cost_cr}
                    className={`ca_input ${errors.project_cost_cr
                      ? "ca_input--error"
                      : inputState.project_cost_cr
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.project_cost_cr && (
                    <span className="ca_error-message">
                      {errors.project_cost_cr}
                    </span>
                  )}
                </div>

                <div title="total_consultancy_fees_cr" className="ca_form-field">
                  <label htmlFor="total_consultancy_fees_cr" className="ca_form-label">
                    Total Consultancy Fees (in Crores)
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="total_consultancy_fees_cr"
                    name="total_consultancy_fees_cr"
                    placeholder="e.g. 2.5 (in crores)"
                    onChange={handleInputChange}
                    value={formData.total_consultancy_fees_cr}
                    className={`ca_input ${errors.total_consultancy_fees_cr
                      ? "ca_input--error"
                      : inputState.total_consultancy_fees_cr
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.total_consultancy_fees_cr && (
                    <span className="ca_error-message">
                      {errors.total_consultancy_fees_cr}
                    </span>
                  )}
                </div>

                <div title="participate_as" className="ca_form-field">
                  <label htmlFor="participate_as" className="ca_form-label">
                    Participate AS
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="participate_as"
                    name="participate_as"
                    placeholder="Participate AS"
                    onChange={handleInputChange}
                    value={formData.participate_as}
                    className={`ca_input ${errors.participate_as
                      ? "ca_input--error"
                      : inputState.participate_as
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.participate_as && (
                    <span className="ca_error-message">
                      {errors.participate_as}
                    </span>
                  )}
                </div>

                <div title="special_structure" className="ca_form-field">
                  <label htmlFor="special_structure" className="ca_form-label">
                    Special Structure
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="special_structure"
                    name="special_structure"
                    placeholder="Special Structure"
                    onChange={handleInputChange}
                    value={formData.special_structure}
                    className={`ca_input ${errors.special_structure
                      ? "ca_input--error"
                      : inputState.special_structure
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.special_structure && (
                    <span className="ca_error-message">
                      {errors.special_structure}
                    </span>
                  )}
                </div>

                <div title="share_mention_on_clientcertificate" className="ca_form-field">
                  <div className="ca_toggle-row">
                    <label htmlFor="share_mention_on_clientcertificate" className="ca_form-label">
                      Share as per Client Certificate
                    </label>
                    <hr className="ca_toggle-divider" />
                    <label className="ca_toggle-switch">
                      <input
                        id="share_mention_on_clientcertificate"
                        name="share_mention_on_clientcertificate"
                        type="checkbox"
                        value={formData.share_mention_on_clientcertificate}
                        onChange={handleInputChange}
                        checked={formData.share_mention_on_clientcertificate}
                      />
                      <span className="ca_toggle-slider"></span>
                    </label>
                  </div>
                  {formData.share_mention_on_clientcertificate === true && (
                    <>
                      <input
                        type="number"
                        maxLength={100}
                        id="share_asper_certificate"
                        name="share_asper_certificate"
                        placeholder="Share as per Client Certificate"
                        onChange={handleInputChange}
                        value={formData.share_asper_certificate}
                        className={`ca_input ${errors.share_asper_certificate
                          ? "ca_input--error"
                          : inputState.share_asper_certificate
                            ? "ca_input--success"
                            : ""
                          }`}
                      />
                      {errors.share_asper_certificate && (
                        <span className="ca_error-message">
                          {errors.share_asper_certificate}
                        </span>
                      )}
                    </>
                  )}
                </div>

                <div title="CA_Certificate_available" className="ca_form-field">
                  <div className="ca_toggle-row">
                    <label htmlFor="CA_Certificate_available" className="ca_form-label">
                      Share as per CA Certificate
                    </label>
                    <hr className="ca_toggle-divider" />
                    <label className="ca_toggle-switch">
                      <input
                        id="CA_Certificate_available"
                        name="CA_Certificate_available"
                        type="checkbox"
                        value={formData.CA_Certificate_available}
                        onChange={handleInputChange}
                        checked={formData.CA_Certificate_available}
                      />
                      <span className="ca_toggle-slider"></span>
                    </label>
                  </div>
                  {formData.CA_Certificate_available === true && (
                    <>
                      <input
                        type="number"
                        maxLength={100}
                        id="share_as_per_ca_certificate"
                        name="share_as_per_ca_certificate"
                        placeholder="Share as per CA Certificate"
                        onChange={handleInputChange}
                        value={formData.share_as_per_ca_certificate}
                        className={`ca_input ${errors.share_as_per_ca_certificate
                          ? "ca_input--error"
                          : inputState.share_as_per_ca_certificate
                            ? "ca_input--success"
                            : ""
                          }`}
                      />
                      {errors.share_as_per_ca_certificate && (
                        <span className="ca_error-message">
                          {errors.share_as_per_ca_certificate}
                        </span>
                      )}
                    </>
                  )}
                </div>

                <div title="remark" className="ca_form-field ca_form-field--full">
                  <label htmlFor="remark" className="ca_form-label">
                    Remarks
                  </label>
                  <input
                    type="text"
                    id="remark"
                    name="remark"
                    placeholder="Remarks"
                    onChange={handleInputChange}
                    value={formData.remark}
                    className={`ca_input ${errors.remark ? "ca_input--error" : inputState.remark ? "ca_input--success" : ""
                      }`}
                  />
                  {errors.remark && (
                    <span className="ca_error-message">
                      {errors.remark}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {uploadProgress > 0 && (
            <div className="ca_progress-wrap">
              <div className="ca_progress-label">Uploading {uploadProgress}%</div>
              <div className="ca_progress-track">
                <div className="ca_progress-fill" style={{ width: `${uploadProgress}%` }}></div>
              </div>
            </div>
          )}

          <div className="ca_modal-footer">
            <button
              onClick={handleFormSubmit}
              className="ca_btn"
              disabled={loading}
              type="button"
            >
              Submit
            </button>
          </div>
          {isSubmitted && Object.keys(errors).length > 0 && (
            <p className="ca_form-error-summary">
              {Object.keys(errors).length > 5
                ? "Please fill all mandatory fields!"
                : Object.keys(errors)
                  .map((field) => field.charAt(0).toUpperCase() + field.slice(1))
                  .join(", ") + " are required!"}
            </p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

const UpdateFormat = ({
  updateTrackRecord,
  toggleCompany,
  siteSubCompanyList,
  i,
}) => {
  const [show, setShow] = useState(false);
  const [fileNames, setFileNames] = useState([]);
  const [showMoreDetails, setShowMoreDetails] = useState(false);

  const handleShow = () => {
    setShow(true);

    setFormData((prev) => ({
      ...prev,
      ...i,
      sub_company: i.sub_company || toggleCompany || "null",
    }));
  };

  const handleClose = () => {
    setShow(false);
  };

  const [formData, setFormData] = useState({
    project: null,
    project_code: "",
    project_short_name: "",
    project_type: "",
    project_name: "",
    client: "",
    project_length: "",
    lane: "",
    length: "",
    special_structure: "",
    participate_as: "",
    share_mention_on_clientcertificate: false,
    share_asper_certificate: "",
    CA_Certificate_available: false,
    share_as_per_ca_certificate: "",
    project_cost_cr: "",
    total_consultancy_fees_cr: "",
    completion_date: null,
    remark: "",
    sub_company: toggleCompany ? toggleCompany : "null",
  });
  const [projectbyId, setProjectbyID] = useState("null");

  const [buffer, setBuffering] = useState(true); //buffering logic
  const [projectList, setProjectList] = useState([]);

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateForm = () => {
    const requiredFields = [];

    const newErrors = requiredFields.reduce((acc, field) => {
      if (
        !formData[field] ||
        (Array.isArray(formData[field]) && formData[field].length === 0)
      ) {
        acc[field] =
          `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
      return acc;
    }, {});

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const getProject = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const pro = await axios.get(
        `${BASE_URL}/siteproject/projectfilterbysubcompany/${formData.sub_company}/`,
      );
      const sortedList = sortProjects(pro.data, "site_prcode");
      setProjectList(sortedList);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    if (formData.sub_company && show === true) {
      getProject();
    }
  }, [formData.sub_company, show]);

  useEffect(() => {
    if (formData.project && projectbyId) {
      setFormData((prevData) => ({
        ...prevData,
        project_short_name: projectbyId.project_short_name,
        project_name: projectbyId.project_name,
        project_code: projectbyId.site_prcode,
        project_type: projectbyId.work_type,
        client: projectbyId.client_name,
        project_length: projectbyId.project_length,
        length: projectbyId.location,
      }));
    }
  }, [formData.project, projectbyId]);

  useEffect(() => {
    if (!i) {
      setFormData((prev) => ({
        ...prev,
        project_short_name: "",
        project_name: "",
        project_code: "",
        project_type: "",
        client: "",
        project_length: "",
        project: null,
        length: "",
      }));
    }
  }, [formData.sub_company]);

  useEffect(() => {
    if (formData.project === "null" && formData.project === null) {
      setFormData((prevData) => ({
        ...prevData,
        project_short_name: "",
        project_name: "",
        project_code: "",
        project_type: "",
        client: "",
        project_length: "",
        length: "",
      }));
    }
  }, [formData.project]);

  console.log("formData");
  console.log(formData);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      sub_company: toggleCompany,
    }));
  }, [toggleCompany]);

  const getProjectbyID = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/projectbyid/${formData.project}/`,
      );
      setProjectbyID(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (formData.project !== "null" && show === true) {
      getProjectbyID();
    }
  }, [formData.project, show]);

  const handleDocInputChange = (index, e) => {
    const { name, value, files } = e.target;

    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData.documents];
      newDocuments[index] = {
        ...newDocuments[index],
        [name]: files ? files[0] : value, // Removed .trim()
      };

      if (files) {
        setFileNames((prevFileNames) => {
          const newFileNames = [...prevFileNames];
          newFileNames[index] = files[0]?.name || "";
          return newFileNames;
        });
      }

      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        if (name === "document_name" && value.trim()) {
          delete updatedErrors[`document_name_${index}`];
        }
        if (name === "document_file" && files?.[0]) {
          delete updatedErrors[`document_file_${index}`];
        }
        return updatedErrors;
      });

      return { ...prevFormData, documents: newDocuments };
    });
  };

  const handleAddDocuments = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: [
        ...prevFormData.documents,
        { document_name: "", document_file: null },
      ],
    }));
  };

  const handleRemoveDocument = (index) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: prevFormData.documents.filter((_, i) => i !== index),
    }));
    setFileNames((prevFileNames) =>
      prevFileNames.filter((_, i) => i !== index),
    );
  };

  const [loading, setLoading] = useState(false);

  const [uploadProgress, setUploadProgress] = useState(0); // For upload progress

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      // const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        const res = await axios.put(
          `${BASE_URL}/siteproject/certificateupate/${i.id}/`,
          formData,
          {
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
              setUploadProgress(percentCompleted);
            },
          },
        );

        if (res.status === 200) {
          updateTrackRecord(res.data);
          toast.success("Data updated successfully!");
          handleClose();
        }
      } catch (err) {
        toast.error("Error uploading documents");
        console.error("Error uploading documents", err);
      } finally {
        setLoading(false);
        // toast.dismiss(loadingToastId);
        setUploadProgress(0);
      }
    }
  };

  const handleInputChange = (e, index) => {
    const { name, value, type, checked, options } = e.target;

    let newValue;
    if (type === "select-multiple") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    // Update input state with feedback
    setInputState((prevState) => ({
      ...prevState,
      [name]:
        type === "checkbox"
          ? checked
            ? "green"
            : ""
          : newValue
            ? "green"
            : "",
    }));

    // Update form data with dynamic calculations
    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,
      };
      return updatedFormData;
    });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (value.trim()) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };

  const ProjectListOption = projectList
    ?.sort((a, b) => a.site_prcode.localeCompare(b.site_prcode))
    .map((i) => ({
      value: i.id,
      label: `${i.site_prcode} - ${i.project_short_name}`,
    }));

  const handleProjectChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        project: "",
      });
    } else {
      setFormData({
        ...formData,
        project: selectedOption.value,
      });
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.project;
      return updatedErrors;
    });
  };

  const sortedStatesAndUTs = [...statesAndUTs].sort();

  const [location, setLocation] = useState([]);

  useEffect(() => {
    const uniqueLocations = [
      ...new Set(
        sortedStatesAndUTs
          .map((item) => item?.trim())
          .filter((type) => type && type !== ""),
      ),
    ]
      .sort((a, b) => a.localeCompare(b))
      .map((type) => ({ location: type }));

    setLocation(uniqueLocations);
  }, [statesAndUTs]);

  const StatesOptions = location
    ?.sort((a, b) => a.location.localeCompare(b.location))
    .map((i) => ({
      value: i.location,
      label: `${i.location}`,
    }));

  const handleLocationChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        length: "",
      });
    } else {
      setFormData({
        ...formData,
        length: selectedOption.value,
      });
    }
  };
  return (
    <>
      <button
        title="Update Details"
        className="ca_btn--icon"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ca_modal-section-title">Required Information</div>
          <div className="ca_form-grid">
            <div title="Site Sub Company" className="ca_form-field">
              <label htmlFor="sub_company" className="ca_form-label">
                Site Sub Company <span className="ca_required">*</span>
              </label>
              <select
                id="sub_company"
                name="sub_company"
                value={formData.sub_company}
                onChange={handleInputChange}
                className={`ca_select ${errors.sub_company
                  ? "ca_select--error"
                  : inputState.sub_company
                    ? "ca_select--success"
                    : ""
                  }`}
              >
                <option value="null">Select a Site SubCompany</option>
                {siteSubCompanyList
                  ?.sort((a, b) =>
                    a.title.localeCompare(b.title, "en", {
                      ignorePunctuation: true,
                    }),
                  )
                  .map((i, index) => (
                    <option value={i.id} key={index}>{i.title}</option>
                  ))}
              </select>
              {errors.sub_company && (
                <span className="ca_error-message">
                  {errors.sub_company}
                </span>
              )}
            </div>

            <div title="Project" className="ca_form-field">
              <label htmlFor="project" className="ca_form-label">
                Project
              </label>
              <Select
                options={ProjectListOption}
                onChange={handleProjectChange}
                value={
                  formData.project === "null" ||
                    formData.project === undefined
                    ? "null"
                    : ProjectListOption.find(
                      (option) => option.value === formData.project,
                    )
                }
                placeholder="Select a Project"
                isSearchable
                isClearable
                noOptionsMessage={() => "No other options"}
                styles={caSelectStyles}
              />
              {errors.project && (
                <span className="ca_error-message">
                  {errors.project}
                </span>
              )}
            </div>

            <div title="project_code" className="ca_form-field">
              <label htmlFor="project_code" className="ca_form-label">
                Project Code
              </label>
              <input
                type="text"
                maxLength={100}
                id="project_code"
                name="project_code"
                placeholder="Project Code"
                onChange={handleInputChange}
                value={formData.project_code}
                className={`ca_input ${errors.project_code
                  ? "ca_input--error"
                  : inputState.project_code
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.project_code && (
                <span className="ca_error-message">
                  {errors.project_code}
                </span>
              )}
            </div>

            <div title="project_short_name" className="ca_form-field">
              <label htmlFor="project_short_name" className="ca_form-label">
                Project Short Name
              </label>
              <input
                type="text"
                maxLength={100}
                id="project_short_name"
                name="project_short_name"
                placeholder="Project Short Name"
                onChange={handleInputChange}
                value={formData.project_short_name}
                className={`ca_input ${errors.project_short_name
                  ? "ca_input--error"
                  : inputState.project_short_name
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.project_short_name && (
                <span className="ca_error-message">
                  {errors.project_short_name}
                </span>
              )}
            </div>

            <div title="project_name" className="ca_form-field ca_form-field--full">
              <label htmlFor="project_name" className="ca_form-label">
                Project Full Name
              </label>
              <textarea
                id="project_name"
                name="project_name"
                placeholder="Project Full Name"
                onChange={handleInputChange}
                value={formData.project_name}
                className={`ca_textarea ${errors.project_name
                  ? "ca_input--error"
                  : inputState.project_name
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.project_name && (
                <span className="ca_error-message">
                  {errors.project_name}
                </span>
              )}
            </div>

            <div title="client" className="ca_form-field">
              <label htmlFor="client" className="ca_form-label">
                Client
              </label>
              <input
                type="text"
                maxLength={100}
                id="client"
                name="client"
                placeholder="Client"
                onChange={handleInputChange}
                value={formData.client}
                className={`ca_input ${errors.client ? "ca_input--error" : inputState.client ? "ca_input--success" : ""
                  }`}
              />
              {errors.client && (
                <span className="ca_error-message">
                  {errors.client}
                </span>
              )}
            </div>

            <div title="Completion Date" className="ca_form-field">
              <label htmlFor="completion_date" className="ca_form-label">
                Completion Date
              </label>
              <input
                type="date"
                id="completion_date"
                name="completion_date"
                onChange={handleInputChange}
                value={formData.completion_date}
                className={`ca_input ${errors.completion_date
                  ? "ca_input--error"
                  : inputState.completion_date
                    ? "ca_input--success"
                    : ""
                  }`}
              />
              {errors.completion_date && (
                <span className="ca_error-message">
                  {errors.completion_date}
                </span>
              )}
            </div>
          </div>

          <div className="ca_disclosure">
            <button
              type="button"
              className="ca_disclosure-toggle"
            // onClick={() => setShowMoreDetails((p) => !p)}
            >
              Additional Details (Optional)
              {/* <span className={`ca_expand-arrow ${showMoreDetails ? "ca_expand-arrow--open" : ""}`}>▼</span> */}
            </button>
            {/* <div className={`ca_disclosure-body ${showMoreDetails ? "" : "ca_disclosure-body--closed"}`}> */}
            <div className="ca_disclosure-body">
              <div className="ca_form-grid">
                <div title="project_type" className="ca_form-field">
                  <label htmlFor="project_type" className="ca_form-label">
                    Project Type
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="project_type"
                    name="project_type"
                    placeholder="Project type"
                    onChange={handleInputChange}
                    value={formData.project_type}
                    className={`ca_input ${errors.project_type
                      ? "ca_input--error"
                      : inputState.project_type
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.project_type && (
                    <span className="ca_error-message">
                      {errors.project_type}
                    </span>
                  )}
                </div>

                <div title="State" className="ca_form-field">
                  <label htmlFor="length" className="ca_form-label">
                    State
                  </label>
                  <Select
                    options={StatesOptions}
                    onChange={handleLocationChange}
                    value={StatesOptions.find(
                      (option) => option.value === formData.length,
                    )}
                    placeholder="Select a Location"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No other options"}
                    styles={caSelectStyles}
                  />
                  {errors.length && (
                    <span className="ca_error-message">
                      {errors.length}
                    </span>
                  )}
                </div>

                <div title="project_length" className="ca_form-field">
                  <label htmlFor="project_length" className="ca_form-label">
                    Project Length
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="project_length"
                    name="project_length"
                    placeholder="Project Length"
                    onChange={handleInputChange}
                    value={formData.project_length}
                    className={`ca_input ${errors.project_length
                      ? "ca_input--error"
                      : inputState.project_length
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.project_length && (
                    <span className="ca_error-message">
                      {errors.project_length}
                    </span>
                  )}
                </div>

                <div title="lane" className="ca_form-field">
                  <label htmlFor="lane" className="ca_form-label">
                    Lane
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="lane"
                    name="lane"
                    placeholder="Lane"
                    onChange={handleInputChange}
                    value={formData.lane}
                    className={`ca_input ${errors.lane ? "ca_input--error" : inputState.lane ? "ca_input--success" : ""
                      }`}
                  />
                  {errors.lane && (
                    <span className="ca_error-message">
                      {errors.lane}
                    </span>
                  )}
                </div>

                <div title="project_cost_cr" className="ca_form-field">
                  <label htmlFor="project_cost_cr" className="ca_form-label">
                    Project Cost (in Crores)
                  </label>
                  <input
                    type="number"
                    maxLength={100}
                    id="project_cost_cr"
                    name="project_cost_cr"
                    placeholder="Project Cost"
                    onChange={handleInputChange}
                    value={formData.project_cost_cr}
                    className={`ca_input ${errors.project_cost_cr
                      ? "ca_input--error"
                      : inputState.project_cost_cr
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.project_cost_cr && (
                    <span className="ca_error-message">
                      {errors.project_cost_cr}
                    </span>
                  )}
                </div>

                <div title="total_consultancy_fees_cr" className="ca_form-field">
                  <label htmlFor="total_consultancy_fees_cr" className="ca_form-label">
                    Total Consultancy Fees (in Crores)
                  </label>
                  <input
                    type="number"
                    min={0}
                    id="total_consultancy_fees_cr"
                    name="total_consultancy_fees_cr"
                    placeholder="e.g. 2.5 (in crores)"
                    onChange={handleInputChange}
                    value={formData.total_consultancy_fees_cr}
                    className={`ca_input ${errors.total_consultancy_fees_cr
                      ? "ca_input--error"
                      : inputState.total_consultancy_fees_cr
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.total_consultancy_fees_cr && (
                    <span className="ca_error-message">
                      {errors.total_consultancy_fees_cr}
                    </span>
                  )}
                </div>

                <div title="participate_as" className="ca_form-field">
                  <label htmlFor="participate_as" className="ca_form-label">
                    Participate AS
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="participate_as"
                    name="participate_as"
                    placeholder="Participate AS"
                    onChange={handleInputChange}
                    value={formData.participate_as}
                    className={`ca_input ${errors.participate_as
                      ? "ca_input--error"
                      : inputState.participate_as
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.participate_as && (
                    <span className="ca_error-message">
                      {errors.participate_as}
                    </span>
                  )}
                </div>

                <div title="special_structure" className="ca_form-field">
                  <label htmlFor="special_structure" className="ca_form-label">
                    Special Structure
                  </label>
                  <input
                    type="text"
                    maxLength={100}
                    id="special_structure"
                    name="special_structure"
                    placeholder="Special Structure"
                    onChange={handleInputChange}
                    value={formData.special_structure}
                    className={`ca_input ${errors.special_structure
                      ? "ca_input--error"
                      : inputState.special_structure
                        ? "ca_input--success"
                        : ""
                      }`}
                  />
                  {errors.special_structure && (
                    <span className="ca_error-message">
                      {errors.special_structure}
                    </span>
                  )}
                </div>

                <div title="share_mention_on_clientcertificate" className="ca_form-field">
                  <div className="ca_toggle-row">
                    <label htmlFor="share_mention_on_clientcertificate" className="ca_form-label">
                      Share as per Client Certificate
                    </label>
                    <hr className="ca_toggle-divider" />
                    <label className="ca_toggle-switch">
                      <input
                        id="share_mention_on_clientcertificate"
                        name="share_mention_on_clientcertificate"
                        type="checkbox"
                        value={formData.share_mention_on_clientcertificate}
                        onChange={handleInputChange}
                        checked={formData.share_mention_on_clientcertificate}
                      />
                      <span className="ca_toggle-slider"></span>
                    </label>
                  </div>
                  {formData.share_mention_on_clientcertificate === true && (
                    <>
                      <input
                        type="number"
                        maxLength={100}
                        id="share_asper_certificate"
                        name="share_asper_certificate"
                        placeholder="Share as per Client Certificate"
                        onChange={handleInputChange}
                        value={formData.share_asper_certificate}
                        className={`ca_input ${errors.share_asper_certificate
                          ? "ca_input--error"
                          : inputState.share_asper_certificate
                            ? "ca_input--success"
                            : ""
                          }`}
                      />
                      {errors.share_asper_certificate && (
                        <span className="ca_error-message">
                          {errors.share_asper_certificate}
                        </span>
                      )}
                    </>
                  )}
                </div>

                <div title="CA_Certificate_available" className="ca_form-field">
                  <div className="ca_toggle-row">
                    <label htmlFor="CA_Certificate_available" className="ca_form-label">
                      Share as per CA Certificate
                    </label>
                    <hr className="ca_toggle-divider" />
                    <label className="ca_toggle-switch">
                      <input
                        id="CA_Certificate_available"
                        name="CA_Certificate_available"
                        type="checkbox"
                        value={formData.CA_Certificate_available}
                        onChange={handleInputChange}
                        checked={formData.CA_Certificate_available}
                      />
                      <span className="ca_toggle-slider"></span>
                    </label>
                  </div>
                  {formData.CA_Certificate_available === true && (
                    <>
                      <input
                        type="number"
                        maxLength={100}
                        id="share_as_per_ca_certificate"
                        name="share_as_per_ca_certificate"
                        placeholder="Share as per CA Certificate"
                        onChange={handleInputChange}
                        value={formData.share_as_per_ca_certificate}
                        className={`ca_input ${errors.share_as_per_ca_certificate
                          ? "ca_input--error"
                          : inputState.share_as_per_ca_certificate
                            ? "ca_input--success"
                            : ""
                          }`}
                      />
                      {errors.share_as_per_ca_certificate && (
                        <span className="ca_error-message">
                          {errors.share_as_per_ca_certificate}
                        </span>
                      )}
                    </>
                  )}
                </div>

                <div title="remark" className="ca_form-field ca_form-field--full">
                  <label htmlFor="remark" className="ca_form-label">
                    Remarks
                  </label>
                  <input
                    type="text"
                    id="remark"
                    name="remark"
                    placeholder="Remarks"
                    onChange={handleInputChange}
                    value={formData.remark}
                    className={`ca_input ${errors.remark ? "ca_input--error" : inputState.remark ? "ca_input--success" : ""
                      }`}
                  />
                  {errors.remark && (
                    <span className="ca_error-message">
                      {errors.remark}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>

          {uploadProgress > 0 && (
            <div className="ca_progress-wrap">
              <div className="ca_progress-label">Uploading {uploadProgress}%</div>
              <div className="ca_progress-track">
                <div className="ca_progress-fill" style={{ width: `${uploadProgress}%` }}></div>
              </div>
            </div>
          )}

          <div className="ca_modal-footer">
            <button
              onClick={handleFormSubmit}
              className="ca_btn"
              disabled={loading}
              type="button"
            >
              Submit
            </button>
          </div>
          {isSubmitted && Object.keys(errors).length > 0 && (
            <p className="ca_form-error-summary">
              {Object.keys(errors).length > 5
                ? "Please fill all mandatory fields!"
                : Object.keys(errors)
                  .map((field) => field.charAt(0).toUpperCase() + field.slice(1))
                  .join(", ") + " are required!"}
            </p>
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

const DeleteFormat = ({ i, getcertification }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/certificateupate/${i.id}/`,
      );

      if (res.status === 200) {
        await getcertification();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete Button"
        className="ca_btn--icon ca_btn--icon-danger"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            Are You Sure You Want to delete Data?
            <div className="ca_modal-footer">
              <button
                className="ca_btn ca_btn--cancel"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="ca_btn ca_btn--danger"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const CertificateFormat = ({
  projectId,
  letterBy,
  contractor,
  contractorlist,
}) => {
  const tableRef = useRef(null);
  const [toggleCompany, setToggleCompany] = useState("null");
  const [toggleProjectType, setToggleProjectType] = useState("null");
  const [toggleClient, setToggleClient] = useState("null");
  const [toggleLocation, setToggleLocation] = useState("null");
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);

  const [workperformedby, setWorkperformedby] = useState("null");

  const [lettertype, setLetterType] = useState("null");
  const [structureList, setstructureList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [error, setError] = useState(null);

  const [selectedNo, setNo] = useState("");
  const [selectedFromDate, setFromDate] = useState("null");
  const [selectedToDate, setToDate] = useState("null");
  const [structure, setStructure] = useState("null");
  const [sector, setSector] = useState("null");
  const [service, setService] = useState("null");
  const [selectedProject, setSelectedProject] = useState("null");

  const [trackRecordList, setTrackRecordList] = useState([]);

  const [buffer, setBuffering] = useState(false);
  const [bufferForProjectType, setbufferForProjectType] = useState(false);
  const [bufferForSubcompany, setbufferForSubcompany] = useState(false);

  /* expand/collapse for non-mandatory columns, per row */
  const [expandedRows, setExpandedRows] = useState({});
  const toggleExpand = (id) => {
    setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const getcompany = async () => {
    setbufferForSubcompany(true); // Start Buffering
    try {
      const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSiteSubCompanyList(sub.data);
    } catch (err) {
      // handleErrorToast(err); // You can handle any general error here if needed
    } finally {
      setbufferForSubcompany(false); // End Buffering
    }
  };

  const getProjects = async () => {
    setBuffering(true); // Start Buffering
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/certificatefilter/${toggleProjectType}/${toggleClient}/${selectedFromDate}/${selectedToDate}/${toggleCompany}/`,
      );
      setTrackRecordList(res.data);
    } catch (err) {
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getcompany();
  }, []);

  useEffect(() => {
    getProjects();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedFromDate,
    selectedToDate,
    toggleProjectType,
    toggleClient,
    toggleCompany,
  ]);

  console.log("selectedFromDate");
  console.log(selectedFromDate);

  useEffect(() => {
    applyFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggleLocation, trackRecordList]);

  const applyFilters = () => {
    let filteredData = trackRecordList;
    if (toggleLocation !== "null") {
      filteredData = filteredData.filter((i) => i.length === toggleLocation);
    }

    setFilteredData(filteredData);
  };

  const [dataForFilter, setDataForFilter] = useState([]);
  const [clientForFilter, setClientForFilter] = useState([]);
  const [bufferForClient, setBufferForClient] = useState(false);

  const getDataForFilter = async () => {
    setbufferForProjectType(true);
    setBufferForClient(true);

    try {
      const res = await axios.get(`${BASE_URL}/siteproject/certificate/`);

      // Unique project_type
      const uniqueProjectTypes = [
        ...new Set(
          res.data
            .map((item) => item.project_type?.trim())
            .filter((type) => type && type !== ""),
        ),
      ]
        .sort((a, b) => a.localeCompare(b))
        .map((type) => ({ project_type: type }));

      setDataForFilter(uniqueProjectTypes);

      // Unique client
      const uniqueClients = [
        ...new Set(
          res.data
            .map((item) => item.client?.trim())
            .filter((client) => client && client !== ""),
        ),
      ]
        .sort((a, b) => a.localeCompare(b))
        .map((client) => ({ client: client }));

      setClientForFilter(uniqueClients);
    } catch (error) {
      console.error(error);
    } finally {
      setbufferForProjectType(false);
      setBufferForClient(false);
    }
  };

  useEffect(() => {
    getDataForFilter();
  }, []);

  const projectTypeData = [
    ...dataForFilter.map((i) => ({
      value: i.project_type,
      label: i.project_type,
    })),
  ];
  const clientData = [
    ...clientForFilter.map((i) => ({
      value: i.client,
      label: i.client,
    })),
  ];
  console.log("projectTypeData", clientForFilter);
  console.log(projectTypeData);

  const handleProjectTypeFilter = (option) => {
    if (!option) {
      setToggleProjectType("null");
      return;
    }
    setToggleProjectType(option.value);
  };
  const handleClientFilter = (option) => {
    if (!option) {
      setToggleClient("null");
      return;
    }
    setToggleClient(option.value);
  };

  console.log("dataForFilter");
  console.log(dataForFilter);
  const updateTrackRecord = (updatedItem) => {
    setTrackRecordList((prev) =>
      prev.map((item) => (item.id === updatedItem.id ? updatedItem : item)),
    );
  };

  const sortedStatesAndUTs = [...statesAndUTs].sort();

  const [location, setLocation] = useState([]);

  useEffect(() => {
    const uniqueLocations = [
      ...new Set(
        sortedStatesAndUTs
          .map((item) => item?.trim())
          .filter((type) => type && type !== ""),
      ),
    ]
      .sort((a, b) => a.localeCompare(b))
      .map((type) => ({ location: type }));

    setLocation(uniqueLocations);
  }, [statesAndUTs]);

  const StatesOptions = location
    ?.sort((a, b) => a.location.localeCompare(b.location))
    .map((i) => ({
      value: i.location,
      label: `${i.location}`,
    }));

  const handleStateFilter = (option) => {
    if (!option) {
      setToggleLocation("null");
      return;
    }
    setToggleLocation(option.value);
  };

  const [toggleState, setToggleState] = useState(1);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div className="ca_header">
        <div className="ca_header-title">Company Credentials</div>
        <div className="ca_header-actions">
          <Addformat
            getFormat={getProjects}
            siteSubCompanyList={siteSubCompanyList}
            toggleCompany={toggleCompany}
          />
          <UploadCompanyCredit
            getData={getProjects}
            subcompanyList={siteSubCompanyList}
          />
        </div>
      </div>

      <div className="ca_filterbar">
        <div className="ca_filter-field">
          <label className="ca_filter-label">
            {bufferForSubcompany && <span className="ca_spinner-vsmall" />} Sub Company
          </label>
          <select
            onChange={(e) => setToggleCompany(e.target.value)}
            value={toggleCompany}
            className="ca_filter-select"
          >
            <option value="null">Sub Company</option>
            {siteSubCompanyList.map((company, idx) => (
              <option value={company.id} key={idx}>{company.title}</option>
            ))}
          </select>
        </div>

        <div className="ca_filter-field">
          <label className="ca_filter-label">
            {bufferForProjectType && <span className="ca_spinner-vsmall" />} Project Type
          </label>
          <Select
            options={projectTypeData}
            value={
              projectTypeData.find(
                (item) => item.value === toggleProjectType,
              ) || null
            }
            onChange={handleProjectTypeFilter}
            isClearable
            placeholder="Select Project-Type"
            styles={caFilterSelectStyles}
          />
        </div>

        <div className="ca_filter-field">
          <label className="ca_filter-label">
            {bufferForProjectType && <span className="ca_spinner-vsmall" />} State
          </label>
          <Select
            options={StatesOptions}
            value={
              StatesOptions.find(
                (item) => item.value === toggleLocation,
              ) || null
            }
            onChange={handleStateFilter}
            isClearable
            placeholder="Select Location"
            styles={caFilterSelectStyles}
          />
        </div>

        <div className="ca_filter-field">
          <label className="ca_filter-label">
            {bufferForClient && <span className="ca_spinner-vsmall" />} Client
          </label>
          <Select
            options={clientData}
            value={
              clientData.find((item) => item.value === toggleClient) || null
            }
            onChange={handleClientFilter}
            isClearable
            placeholder="Select Client"
            styles={caFilterSelectStyles}
          />
        </div>

        <div className="ca_filter-field">
          <label className="ca_filter-label">Date Range</label>
          <div className="ca_filter-daterange">
            <DateRangePicker
              startDate={selectedFromDate}
              endDate={selectedToDate}
              placeHolder1="From Date"
              placeHolder2="To Date"
              onChange={(start, end) => {
                setFromDate(start);
                setToDate(end);
              }}
            />
          </div>
        </div>

        <div className="ca_filterbar-right">
          <span className="ca_filter-count">
            Showing <strong>{filteredData.length}</strong> of{" "}
            <strong>{filteredData.length}</strong>
          </span>
        </div>
      </div>

      <div className="ca_table-scroll">
        <table ref={tableRef} className="ca_table">
          <thead>
            <tr>
              <th className="ca_th">S.no.</th>
              <th className="ca_th">Company Name</th>
              <th className="ca_th">Project Code</th>
              <th className="ca_th">Project Short Name</th>
              <th className="ca_th">Project Full Name</th>
              <th className="ca_th">State</th>
              <th className="ca_th">Client</th>
              <th className="ca_th">Completion Date</th>
              <th className="ca_th ca_th--center">Details</th>
              {sessionStorage.getItem("sitemanagement_role") === "BD" ? null : (
                <>
                  <th className="ca_th ca_th--center">Documents</th>
                  <th className="ca_th ca_th--center">Edit</th>
                  <th className="ca_th ca_th--center">Delete</th>
                </>
              )}
            </tr>
          </thead>
          {buffer ? (
            <tbody>
              <tr className="ca_spinner-row">
                <td colSpan={12}>Loading…</td>
              </tr>
            </tbody>
          ) : error ? (
            <tbody>
              <tr>
                <td colSpan={12} className="ca_empty-row">
                  Error fetching data: {error.message}
                </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              {filteredData.length === 0 && (
                <tr>
                  <td colSpan={12} className="ca_empty-row">
                    No company credential records found.
                  </td>
                </tr>
              )}
              {filteredData.map((i, index) => (
                <React.Fragment key={index}>
                  <tr
                    className={`ca_row ${index % 2 === 1 ? "ca_row--even" : ""} ${expandedRows[i.id] ? "ca_row--expanded" : ""}`}
                  >
                    <td className="ca_td">{index + 1}.</td>
                    <td className="ca_td">{i.sub_company_name ? i.sub_company_name : "-"}</td>
                    <td className="ca_td">{i.project_code ? i.project_code : "-"}</td>
                    <td className="ca_td">{i.project_short_name ? i.project_short_name : "-"}</td>
                    <td className="ca_td ca_td--name">{i.project_name ? i.project_name : "-"}</td>
                    <td className="ca_td">{i.length ? i.length : "-"}</td>
                    <td className="ca_td">{i.client ? i.client : "-"}</td>
                    <td className="ca_td ca_td--center">
                      {i.completion_date ? formatDate(i.completion_date) : "-"}
                    </td>
                    <td className="ca_td ca_td--center">
                      <button
                        className="ca_expand-btn"
                        onClick={() => toggleExpand(i.id)}
                      >
                        {expandedRows[i.id] ? "Hide" : "More"}
                        <span className={`ca_expand-arrow ${expandedRows[i.id] ? "ca_expand-arrow--open" : ""}`}>▼</span>
                      </button>
                    </td>
                    {sessionStorage.getItem("sitemanagement_role") === "BD" ? null : (
                      <>
                        <td className="ca_td ca_td--center">
                          <DocumentModel
                            title="LOA & Certificate Document"
                            certificate={i.id}
                          />
                        </td>
                        <td className="ca_td ca_td--center">
                          <UpdateFormat
                            i={i}
                            updateTrackRecord={updateTrackRecord}
                            siteSubCompanyList={siteSubCompanyList}
                            toggleCompany={toggleCompany}
                          />
                        </td>
                        <td className="ca_td ca_td--center">
                          <DeleteFormat i={i} getcertification={getProjects} />
                        </td>
                      </>
                    )}
                  </tr>

                  {expandedRows[i.id] && (
                    <tr className="ca_expand-row">
                      <td colSpan={sessionStorage.getItem("sitemanagement_role") === "BD" ? 9 : 12}>
                        <div className="ca_expand-body">
                          <div className="ca_detail-grid">
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">Project Type</span>
                              <span className="ca_detail-value">{i.project_type ? i.project_type : "-"}</span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">Lane Type</span>
                              <span className="ca_detail-value">{i.lane ? `${i.lane} Lane` : "-"}</span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">Total Length</span>
                              <span className="ca_detail-value">{i.project_length ? `${i.project_length}KM` : "-"}</span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">Total Cost</span>
                              <span className="ca_detail-value">{i.project_cost_cr ? `₹ ${i.project_cost_cr} Cr` : "-"}</span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">Consultancy Fees</span>
                              <span className="ca_detail-value">{i.total_consultancy_fees_cr ? `₹ ${i.total_consultancy_fees_cr} Cr` : "-"}</span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">Participate As</span>
                              <span className="ca_detail-value">{i.participate_as ? i.participate_as : "-"}</span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">Share Mention on Client Certificate</span>
                              <span className="ca_detail-value">{i.share_mention_on_clientcertificate ? "Yes" : "No"}</span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">Share as per Client Certificate</span>
                              <span className="ca_detail-value">{i.share_asper_certificate ? `${i.share_asper_certificate}%` : "-"}</span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">Share Mention on CA Certificate</span>
                              <span className="ca_detail-value">{i.CA_Certificate_available ? "Yes" : "No"}</span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">Share as per CA Certificate</span>
                              <span className="ca_detail-value">{i.share_as_per_ca_certificate ? `${i.share_as_per_ca_certificate}%` : "-"}</span>
                            </div>
                            <div className="ca_detail-field">
                              <span className="ca_detail-label">Special Structure</span>
                              <span className="ca_detail-value">{i.special_structure ? i.special_structure : "-"}</span>
                            </div>
                            <div className="ca_detail-field ca_detail-field--full">
                              <span className="ca_detail-label">Remarks</span>
                              <span className="ca_detail-value">{i.remark ? i.remark : "-"}</span>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          )}
        </table>
      </div>

      <div className="ca_statusbar">
        <span>
          Showing <strong>{filteredData.length}</strong> of{" "}
          <strong>{filteredData.length}</strong> records
        </span>
      </div>
    </>
  );
};

export default CertificateFormat;